import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/defi/")({
  beforeLoad: () => {
    throw redirect({
      to: "/defi/positions",
      search: { protocolKey: undefined },
    });
  },
});
